import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  steps: {
    display: 'flex',
    flexDirection: 'column',
    flexAlign: 'flex-start',
    gap: 32,
    width: '100%',
    lineHeight: '24px',
  },
  text: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
  },
  stepBubble: {
    backgroundColor: theme.palette.bgSecondary.main,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    height: 28,
    padding: '0 8px',
    width: 'fit-content',
    color: theme.palette.labraText.primary,
    borderRadius: 4,
    marginRight: 16,
    display: 'flex',
    alignItems: 'center',
    textWrap: 'nowrap',
  },
  linkText: {
    display: 'inline',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  columns: {
    display: 'flex',
    flexDirection: 'column',
  },
  lineText: {
    marginBottom: 8,
  },
  inline: {
    display: 'inline',
  },
  divider: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
  },
}))
